import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { useTranslation } from "react-i18next";

// صف مندوب مبيعات: هدف شهري · نسبة عمولة · حفظ واعتماد.
export const SalesRepRow = ({ row, edit, setEdit, onSave, onApprove }) => {
  const { t } = useTranslation();
  const patch = (key) => (e) =>
    setEdit({ ...edit, [row.rep_id]: { ...edit[row.rep_id], [key]: e.target.value } });

  return (
    <tr className="border-b border-border/30" data-testid={`rep-row-${row.rep_id}`}>
      <td className="p-2 text-xs font-bold">{row.rep_name || row.rep_id}</td>
      <td className="p-2 num font-mono text-xs">{row.invoices}</td>
      <td className="p-2 num font-mono text-xs">{row.issued_amount}</td>
      <td className="p-2 num font-mono text-xs">{row.collected_amount}</td>
      <td className="p-2">
        <NeuInput className="w-24 px-2 py-1 text-xs" data-testid={`rep-target-${row.rep_id}`}
                  defaultValue={row.target_amount} onChange={patch("target")} />
      </td>
      <td className="p-2 num font-mono text-xs">{row.achievement_percent || "—"}</td>
      <td className="p-2">
        <NeuInput className="w-16 px-2 py-1 text-xs" data-testid={`rep-rate-${row.rep_id}`}
                  defaultValue={row.commission_rate} onChange={patch("rate")} />
      </td>
      <td className="p-2 num font-mono text-xs font-bold">{row.commission_amount}</td>
      <td className="p-2">
        <div className="flex flex-wrap gap-1">
          <NeuButton className="px-2 py-1 text-xs" data-testid={`rep-save-${row.rep_id}`}
                     onClick={() => onSave(row)}>{t("sales.reps.save")}</NeuButton>
          <NeuButton variant="primary" className="px-2 py-1 text-xs" disabled={Boolean(row.approved)}
                     data-testid={`rep-approve-${row.rep_id}`} onClick={() => onApprove(row)}>
            {row.approved ? t("sales.reps.done") : t("sales.reps.approve")}
          </NeuButton>
        </div>
      </td>
    </tr>
  );
};
